import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemAiName} from '../AMAI/FormChooseAmai.jsx'
import Model from './ModelAiac.mjs'

export const FormItemAcName = props => (
    <FormItemBizProp
        Model={Model}
        prop="acName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemAcUserCode = props => (
    <FormItemBizProp
        Model={Model}
        prop="acUserCode"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseAiac(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemAiName />
            <FormItemAcUserCode />
            <FormItemAcName />
        </FormChooseDesign>
    )
}
